import Link from 'next/link';
import { Fragment } from 'react';
import styles from 'styles/modules/BrokerDirectory.module.scss';

// [label, href] pairs; the last one is the current page and is not linked.
export default function DirectoryBreadcrumb({ items }) {
    return (
        <nav
            aria-label="Breadcrumb"
            className={styles.breadcrumb}
            data-nosnippet
        >
            {items.map(([label, href], index) => (
                <Fragment key={href}>
                    {index > 0 && <span aria-hidden="true">›</span>}
                    {index < items.length - 1 ? (
                        <Link href={href}>
                            <a>{label}</a>
                        </Link>
                    ) : (
                        <span aria-current="page">{label}</span>
                    )}
                </Fragment>
            ))}
        </nav>
    );
}
